/** @jsxImportSource @emotion/react */
import { Modal } from "./Modal";
import { SpinnerBlock } from "../module/common/Spinner";
import { ModalProps } from "antd";
import { css } from "@emotion/react";
import { StyledText } from "../assets/typography/typography";

type Props = {
  header: string;
  isOpen: boolean;
} & ModalProps;

const bodyStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const LoadingModal = ({ header, isOpen, ...rest }: Props) => {
  return (
    <Modal closable={false} isOpen={isOpen} {...rest}>
      <div css={bodyStyle}>
        <StyledText className="headerFour mb-0">{header}</StyledText>
      </div>
      <SpinnerBlock />
    </Modal>
  );
};
